import { supabase } from '../lib/supabase';

export type DriverIntakeSubmitBody = {
  full_name: string;
  email: string;
  phone: string;
  town_or_region: string;
  date_of_birth: string;
  driving_license_number: string;
  vehicle_make: string;
  vehicle_model: string;
  vehicle_year: number;
  registration_plate: string;
  wheelchair_accessible: boolean;
  passenger_seats: number;
  agrees_video_validation: boolean;
};

export type SupportWorkerIntakeSubmitBody = {
  full_name: string;
  email: string;
  phone: string;
  town_or_region: string;
  date_of_birth: string;
  experience_summary: string;
  has_current_dbs: boolean;
  availability_note?: string;
  agrees_video_validation: boolean;
};

export type IntakeSubmitResult = {
  success: boolean;
  reference?: string;
  submission_id?: string;
  message?: string;
  error?: string;
};

async function invokeIntake<T extends Record<string, unknown>>(
  fn: string,
  body: T,
): Promise<IntakeSubmitResult> {
  const { data, error } = await supabase.functions.invoke(fn, { body });

  if (error) {
    return { success: false, error: error.message || 'Submission failed' };
  }

  const d = data as {
    success?: boolean;
    message?: string;
    reference?: string;
    submission_id?: string;
  } | null;

  if (!d?.success) {
    return {
      success: false,
      error: d?.message || 'Submission failed',
    };
  }

  return {
    success: true,
    reference: d.reference,
    submission_id: d.submission_id,
    message: d.message,
  };
}

export const partnerIntakeService = {
  submitDriver(body: DriverIntakeSubmitBody) {
    return invokeIntake('driver-intake-submit', body);
  },

  submitSupportWorker(body: SupportWorkerIntakeSubmitBody) {
    return invokeIntake('support-worker-intake-submit', body);
  },
};
